import Checkbox from 'emerald-ui/lib/Checkbox';
import populateDocs from './utils/populateDocs';

export default {
  ...populateDocs([{ component: Checkbox, componentName: 'Checkbox' }], 'Checkbox'),
  description:
    'The Checkbox allows to choose a binary option. You can set the label via the label prop or passing the label as a child.',
  codeSamples: [
    {
      title: 'Default',
      scope: { Checkbox },
      whiteBackground: true,
      code: `<Checkbox defaultChecked label="Check me" />`,
    },
  ],
};
